module.exports = __webpack_public_path__ + "img/p17.868c73f1.png";